import React from 'react';
import {Space, Badge} from 'antd';

export type StatusType = 'ACTIVE' | 'INACTIVE' | 'PENDING_REGISTRATION' | 'PENDING_REVIEW';

interface StatusIndicatorProps {
  status: string;
}

const getStatusConfig = (status: string): {color: string; icon: React.ReactNode; label: string} => {
  const upperStatus = (status || '').toUpperCase();

  switch (upperStatus) {
    case 'ACTIVE':
    case 'COMPLETED':
      return {
        color: 'success',
        icon: <Badge status="success" />,
        label: 'Completed',
      };

    case 'IN PROGRESS':
      return {
        color: 'yellow',
        icon: <Badge status="warning" />,
        label: 'In Progress',
      };

    case 'IN_PROCESS':
      return {
        color: 'yellow',
        icon: <Badge status="warning" />,
        label: 'In Progress',
      };

    case 'FAILED':
      return {
        color: 'red',
        icon: <Badge status="error" />,
        label: 'Failed',
      };

    case 'INACTIVE':
      return {
        color: 'error',
        icon: <Badge status="error" />,
        label: 'Inactive',
      };

    case 'PENDING_REGISTRATION':
    case 'PENDING_REVIEW':
      return {
        color: 'warning',
        icon: <Badge status="warning" />,
        label: upperStatus === 'PENDING_REGISTRATION' ? 'Pending Registration' : 'Pending Review',
      };

    default:
      return {
        color: 'default',
        icon: <Badge status="default" />,
        label: status,
      };
  }
};

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({status}) => {
  const config = getStatusConfig(status);

  return (
    <Space size="small">
      <span style={{color: config.color, fontSize: '12px'}}>{config.icon}</span>
      <span>{config.label}</span>
    </Space>
  );
};

export default StatusIndicator;
